import { dto_selected_final_merchant_or_product } from "../../classes/dto-selected-merchant-or-product";
import { dto_cart_checkout } from "../../classes/dto-cart-checkout";
import { Api, BuildVersion, CSP, ENCRYPT_STORAGE } from "../../config/config";
import { dto_Customer } from "../../classes/dto-customer";
import { dto_common } from "../../classes/dto-common";
import { postMethod } from "../post";
import { ENTRY_MODE, TABLE_NO } from "../../database/store-names";
import { getEffectiveDineType } from "../../functions/dine-type";

export const api_ValidateSalesOrderBeforePlacing = () => {
  var url = `${Api}/?ControllerName104=ApiCart`; //
  const entryMode = String(ENCRYPT_STORAGE.getItem(ENTRY_MODE) || "").trim();
  const ISERP = entryMode.toUpperCase() === "QR";
  const resolvedDineType = getEffectiveDineType({
    dineType: dto_common.DineType,
    csp: CSP,
    entryMode,
    tableNo: ENCRYPT_STORAGE.getItem(TABLE_NO),
  });
  return postMethod(
    url,
    '{"SERVICENAME":"ValidateSalesOrderBeforePlacing","MID":' +
      dto_selected_final_merchant_or_product.MID +
      ',"CSID":' +
      dto_Customer.CSID +
      ',"DINETYPE":' +
      resolvedDineType +
      ',"AMOUNT":' +
      dto_cart_checkout.Total +
      ',"APPVERSION":"' +
      BuildVersion +
      '","NIC":"' +
      dto_Customer.NIC +
      '","ZONEID":' +
      dto_common.DeliveryZoneID +
      ',"REFPOSID":0,"ISERP":' +
      ISERP +
      "}"
  );
};

const includeTableNoForDtOrder = (JsonParameter) => {
  if (CSP !== "DT") {
    return JsonParameter;
  }

  const tableNo = String(ENCRYPT_STORAGE.getItem(TABLE_NO) || "").trim();
  if (tableNo === "" || tableNo === "0") {
    return JsonParameter;
  }

  try {
    const parsed =
      typeof JsonParameter === "string"
        ? JSON.parse(JsonParameter)
        : JsonParameter;

    if (
      parsed?.SERVICENAME === "SaveSalesOrder" &&
      Array.isArray(parsed.MOBILEPOSHEADER) &&
      parsed.MOBILEPOSHEADER[0]
    ) {
      parsed.MOBILEPOSHEADER[0].TableNo = tableNo;
    }

    return typeof JsonParameter === "string" ? JSON.stringify(parsed) : parsed;
  } catch (error) {
    return JsonParameter;
  }
};

export const api_SaveSalesOrder = (JsonParameter) => {
  var url = `${Api}/?ControllerName104=ApiCart`; //POSSaveOrder
  return postMethod(url, includeTableNoForDtOrder(JsonParameter));
};

export const api_UploadBankTransferImage = (
  ImageBase64,
  BANKTRANSFERIMAGESTATUS,
  BANKTRANSFERGUID
) => {
  var url = `${Api}/?ControllerName104=ApiCart`; //ImageBase64
  return postMethod(
    url,
    '{"SERVICENAME":"UploadBankTransferImage","ISDELIVERED":' +
      BANKTRANSFERIMAGESTATUS +
      ',"BANKTRANSFERGUID":"' +
      BANKTRANSFERGUID +
      '","IMAGEBASE64":"' +
      ImageBase64 +
      '","VERSION":"' +
      BuildVersion +
      '","CSP":"' +
      dto_common.CSP +
      '","COUNTRYCODE":"' +
      dto_common.NatvieCountry +
      '","COORDINATES":"' +
      dto_common.CurrentCordinate +
      '","NIC":"' +
      dto_Customer.NIC +
      '","CSID":' +
      dto_Customer.CSID +
      "}"
  );
};

export const api_LoadBankTranferBase64 = (BANKTRANSFERGUID) => {
  var url = `${Api}/?ControllerName104=ApiCart`; //ImageBase64
  return postMethod(
    url,
    '{"SERVICENAME":"LoadBankTranferBase64","BANKTRANSFERGUID":"' +
      BANKTRANSFERGUID +
      '"}'
  );
};
